import React from 'react'
import "./Civil.css"
import { Link } from 'react-router-dom'
import  civil from "../../assets2/civilimage.png"


const Civil = () => {
  return (
    <div className='overallcivil'>
        <h1>We do all type of civil projects</h1>
        
        <p>We specialize in providing top-quality civil engineering solutions for college projects.
            Our expertise covers structural, architectural, and construction planning.
            We offer detailed project reports, 2D & 3D designs, and cost estimation.
           Ensuring accuracy and innovation in every project we undertake.
           Dedicated to delivering high-quality results with precision and efficiency.
            Partner with us for reliable and professional civil project assistance</p>
        
        <div  className='civilimg'>
         <img src={civil} alt=""  className='civilinnerimg'/>
        </div>
      
        <p>We provide end-to-end support for all types of civil engineering projects.
              Our team ensures timely delivery with precise documentation and analysis.
               Utilizing advanced tools and techniques for efficient project execution.
                Committed to excellence, innovation, and practical solution  </p>
        
       <div className='hrbtns'>
        <hr />
       <button className='buttonforlink'><Link to="/projects" className='spllink2'>Back to projects</Link></button>
       </div>

         
        
    </div>
  )
}

export default Civil